import { render } from "./quotemensaje_ingles.vue?vue&type=template&id=d456f3be&scoped=true"
import script from "./quotemensaje_ingles.vue?vue&type=script&lang=js"
export * from "./quotemensaje_ingles.vue?vue&type=script&lang=js"

import "./quotemensaje_ingles.vue?vue&type=style&index=0&id=d456f3be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d456f3be"]])

export default __exports__